export const ANIMATION_DEFAULT_TIME = '300ms';
